function findImages(color: string) {
  if (color === "Black") return "/PivotHardware/ghostop_round_black";
  return "/PivotHardware/ghostop_round_ss";
}

export default findImages;
